<template>
  <div class="search-input">
    <i class="material-icons search-icon">search</i>
    <input
      type="text"
      :value="value"
      :placeholder="$t(placeholder)"
      @input="event => emit('input', event.target.value)"
      @keyup.enter="onSearch"
      class="search-field w-full"
    />
    <button v-if="value.length" class="clear-btn" @click="clearInput">
      ✕
    </button>
  </div>
</template>

<script setup>
const props = defineProps({
  value: { type: String, default: '' },
  placeholder: { type: String, default: 'search' }
})

const emit = defineEmits(['input', 'search', 'clear'])

function onSearch() {
  emit('search', props.value)
}

function clearInput() {
  emit('input', '')
  emit('clear')
}
</script>

<style scoped>
.search-input {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 6px 10px;
  background: #fff;
}

.search-icon {
  font-size: 20px;
  color: #888;
  margin-right: 8px;
}

.search-field {
  flex: 1;
  border: none;
  outline: none;
  font-size: 14px;
  padding-right: 24px;
}

.clear-btn {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #888;
}

.search-field:focus {
  outline: none;
}
.search-input:focus-within {
  border-color: #BC1300;
}

.search-input:focus-within .clear-btn {
  color: #BC1300;
}
</style>